<template>
    <div>
        <div class="w" id="content">
            <!-- 当前位置 -->
            <div class="s_tl">
                <div class="left wov">
                    当前位置：<a href="/">首页</a>
                    <code class="lr3">&gt;</code>
                    <a href="javascript:;" @click="catesearch(shopInfo.ptitle,index)">
                        {{shopInfo.ptitle}}
                    </a>
                    <code class="lr3">&gt;</code>
                    <router-link :to="{path:'/shop/shopsearch', query:{cate_id:shopInfo.cate_id}}" target="_blank">
                        {{shopInfo.ctitle}}
                    </router-link>
                    <code class="lr3">&gt;</code>
                    {{shopInfo.title}}
                </div>
            </div>
            <!--  -->
            <div class="goods rel">
                <div class="gd_l left" id="gd_l">
                    <div class="gd_tb">
                        <img width="430" height="430" id="preview" :src="picture" @error="imgError()">
                    </div>
                    <ul id="spic" class="pl_ul">
                        <li class="pl_i" v-for="(pic,index) in shopInfo.img_json" :key="index">
                            <img :src="pic" class="pl_m" height="50" width="50" @mouseover="mouseover($event,index)" @mouseout="mouseout($event)">
                        </li>
                    </ul>
                    <div class="clear"></div>
                </div>
                <!--left over-->
                <div class="gd_r rel left">
                    <h1 class="gh1">{{shopInfo.title}}</h1>
                    <div class="pt_g gh2 mt10">
                        <em class="p_tag">{{shopInfo.sub_title}}</em>
                    </div>
                    <div class="cg_bg over">
                        <div class="over">
                            <p class="gpr left" v-if="shopInfo.types == 7 ">
                                <small>￥</small>
                                {{get_price()}}
                            </p>
                            <p class="gpr left" v-else>
                                <small>￥</small>
                                {{shopInfo.types == 24 ? '0.00' : $fnc.toFixedZ(price)}}
                            </p>
                            <b class="left c9 mt5 ml10" id="gprice" style="text-decoration: line-through;margin-left:15px;margin-right:15px;color:#999">市场价:￥{{shopInfo.market_price}}</b>
                            
                            <em class="i_hot left mt5">热销</em>
                            <em class="left c9 mt5 ml10">已售{{shopInfo.invent_sale}}件</em>
                            <em class=" i_hot left mt5 ml10" style="cursor:pointer" @click="changesc">{{shopInfo.collect?'已收藏':'收藏'}}</em>
                        </div>
                    </div>
                    <!--cover-->
                    <dl class="rel gdl mt10">
                        <dt class="gd_dt c9">邮费</dt>
                        <dd class="c9">包邮</dd>
                    </dl>
                    <dl class="rel gdl mt10">
                        <dt class="gd_dt c9">发货</dt>
                        <dd class="c9">{{shopInfo.delivery_address}}</dd>
                    </dl>
                    <dl class="rel gdl mt10">
                        <dt class="gd_dt c9">保障</dt>
                        <dd class="c9">{{shopInfo.commodity_protection}}</dd>
                    </dl>
                    <div v-if="shopInfo.types != 7 && shopInfo.types != 2 && shopInfo.types != 4">
                        <div v-if="(shopInfo.is_coupon==1 && shopInfo.coupon.length>0) || shopInfo.discount_number>0 || shopInfo.send_score>0 || shopInfo.integral_dk_per>0">
                            <dl class="rel gdl mt10" v-show="shopInfo.is_coupon==1 && shopInfo.coupon.length>0">
                                <dt class="gd_dt c9">优惠卷</dt>
                                <dd class="shop_con" v-show="i<2" v-for="(item,i) in shopInfo.coupon" :key="i">
                                    <span @click="coupon()">满{{item.cdn_xfm}}减{{$fnc.toFixedZ(item.money,0)}}</span>
                                </dd>
                            </dl>
                        </div>
                    </div>
                    <div :data-id="list.id"  class="coupon_tishi" :style="activeFlase">
                        <p @click="closeCT" class="g_close hand"></p>
                        <div v-for="(item,index) in shopInfo.coupon" :key="index" :data-id="item.id">
                            <div style="margin: 0px 0 37px 0;overflow: hidden;display: block;cursor:pointer;"  v-if="item.cdn_pid > 0">
                                <div style="float:left;margin-right:20px;">
                                    <img :src="$fnc.getImgUrl(item.p_piclink)" alt="" style="border-radius: 12px;" width="118">
                                </div>
                                <div style="margin-top:20px;height:98px;">
                                    <p style="color: #f00180;">￥<span style="font-size: 48px; font-weight: 500;margin-right:10px;">{{$fnc.get_int_dec(item.money,'int')}}{{$fnc.get_int_dec(item.money,'dec')}}</span>满{{item.cdn_xfm}}元可用</p>
                                    <div style="float:left;">
                                        <p style="font-size: 15px; height: 24px;line-height: 24px;margin-top: 0px;margin-bottom: 0px;color: #999999;">{{item.p_title}}</p>
                                        <p style="font-size: 18px; color: #333333;line-height: 24px;font-weight: 600;margin-bottom: 0;margin-top: 0;">领后{{item.lifetime}}天有效</p>
                                    </div>
                                    <div style="float: right;margin-right: 53px;padding: 8px 16px;margin-top: 15px;border-radius: 5px;background: #f00180;color: #ffffff;"  @click="user_coupon_zjlq(item)">
                                        {{item.pay_types==0?'立即领取':'立即兑换'}}
                                    </div>
                                    
                                </div>
                            </div>
                            <div style="margin: 0px 0 37px 0;overflow: hidden;display: block;cursor:pointer;"  v-else>
                                <div style="float:left;margin-right:20px;">
                                    <img src="../../assets/picture/index/hongbaored.png" alt="" style="border-radius: 12px;" width="118">
                                </div>
                                <div style="margin-top:20px;height:98px;">
                                    <p style="color: #f00180;">￥<span style="font-size: 48px; font-weight: 500;margin-right:10px;">{{$fnc.get_int_dec(item.money,'int')}}{{$fnc.get_int_dec(item.money,'dec')}}</span>满{{item.cdn_xfm}}元可用</p>
                                    <div style="float:left;">
                                        <p style="font-size: 15px; height: 24px;line-height: 24px;margin-top: 0px;margin-bottom: 0px;color: #999999;">{{item.title}}</p>
                                        <p style="font-size: 18px; color: #333333;line-height: 24px;font-weight: 600;margin-bottom: 0;margin-top: 0;">领后{{item.lifetime}}天有效</p>
                                    </div>
                                    <div style="float: right;margin-right: 53px;padding: 8px 16px;margin-top: 15px;border-radius: 5px;background: #f00180;color: #ffffff;"   @click="user_coupon_zjlq(item)">
                                        {{item.pay_types==0?'立即领取':'立即兑换'}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--overone-->
                    <p class="lh16">&nbsp;</p>
                    <p class="bline"></p>
                    <p class="lh16">&nbsp;</p>
                    <div id="wrap" class="xcolor mb15">
                        <div class="gdl dato" v-if="shopInfo.attr && shopInfo.attr.length>0">
                            <div v-for="(item,i) in shopInfo.attr" :key="i">
                                <p  class="gd_dt mt10 c9">套餐</p>
                                <div class="catt over">
                                    <span class="xc_a" id="sx" :class="[parentList[i]==it.parent_id+':'+it.sku_id?'xc_on':'']" v-for="(it,ii) in item.info" :key="ii" @click="showGg(it,i,item)">
                                        <img :src="it.piclink" height="30" width="30" alt="">
                                        {{it.sku_title}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <!-- <dl class="gdl dato" v-if="shopInfo.attr && shopInfo.attr.length>0">
                            <dt class="gd_dt mt10 c9">套餐</dt>
                            <dd>
                                <div class="catt over">
                                    <div class="xc_a" id="sx" v-for="(item,idx) in shopInfo.sku_json" :key="idx" :class="idx==index?'xc_on':''" @click="taocan(item,idx)">
                                        <i class="c9 pl5">{{item[0].piclink}}</i>
                                        <em class="pl5">{{item[0]}}</em>
                                        <i class="c9 pl5">¥{{item.price}}</i>
                                    </div>
                                </div>
                            </dd>
                        </dl> -->
                    </div>
                    <div class="over">
                        <span class="gd_dt c9">数量</span>
                        <div>
                            <el-input-number v-model="number" @change="handleChange" :min="1" :max="999999"></el-input-number>
                        </div>
                    </div>
                    <div class="bzone rel clearfix">
                        <a href="javascript:;" @click="addToCart" class="car_btn left mr10" id="bigadd" v-if="shopInfo.attr && shopInfo.attr.length>0">加入购物车</a>
                        <a href="javascript:;" @click="lijiBuy" id="buyLiji" class="buy_btn left">
                            <i data-v-ca8bebe2="" class="iconfont icon-gouwuchekong" style="color: rgb(255, 255, 255); font-size: 22px;margin-right:20px;"></i>立即购买
                        </a>
                        <div id="tishi" class="tishi" :style="active" v-if="shopInfo.attr && shopInfo.attr.length>0">
                            <p @click="closeT" class="g_close hand"></p>
                            <table width="100%" border="0" align="center">
                                <tbody>
                                    <tr>
                                        <td width="30" valign="top" rowspan="3">
                                        </td>
                                        <td>
                                            <h4 class="f16 c3">恭喜，您已成功将该商品加入购物车！</h4>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <p id="g_cts" class="c5">
                                                购物车有<b id="rnum" class="red">{{shopInfo.cart_number}}</b>件商品(数量:<em id="num_shu">{{shopInfo.all_cart_number}}</em>),共计
                                                <b id="rsum" class="red">{{$fnc.toFixedZ(all_price)}}</b>
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td height="50">
                                            <a href="javascript:;"  @click="buycar" class="redb left mr10">
                                                去购物车结算&gt;
                                            </a>
                                            <a href="/" class="c9 ml10 mt5 left">继续购物&gt;</a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <dl class="ma_by pt5 pb10" id="ma_by">
                        <dd>
                            <span class="g_bz">正品保证</span>
                            <span class="g_bz">保密配送</span>
                            <span class="g_bz">隐私保护</span>
                            <span class="g_bz">可货到付款</span>
                        </dd>
                    </dl>
                </div>
                <!--mid over-->
                <div class="clear"></div>
            </div>
            <!--goods over-->
            <div class="g_r left rel">
                <div class="jba" id='jba'> 
                    <div id="jbar" class="jbar">
                        <ul id="tabbar" class="jbars">
                            <li @click="on" rel="detail" :class="[ll=='1'?'ll':' ']"><a href="#detail">产品介绍</a></li>
                            <li @click="on1" rel="comment" :class="[ll=='2'?'ll':' ']"><a href="#comment">用户评论 <em class="blue">{{shopInfo.talk_num}}</em></a></li>
                            <li @click="on2" rel="recoment" :class="[ll=='3'?'ll':' ']"><a href="#recoment">相关推荐</a></li>
                            <li @click="on3" rel="shouhou" :class="[ll=='4'?'ll':' ']"><a href="#shouhou">优质服务</a></li>
                        </ul>
                    </div>
                </div>
                <!--jaber over-->
                <div class="des" id="detail">
                    <div id="description" class="gdes lh25">
                        <div class="g_attr mb10">
                            <p title="" class="g_ap" v-for="(p,i) in arr1" :key="i">
                                <em class="c9">{{p.title}}：</em>{{p.desc}}
                            </p>
                        </div> 
                        <div class="mb10 hid" id="video"></div>
                        <div class="hig">
                            <p class="c3">{{shopInfo.sub_title}}</p>
                        </div>
                        
                        <div v-for="(con,index) in shopInfo.content" :key="index">
                            <img :src="con" alt="">
                        </div>
                        
                        <div class="clear"></div>
                        <p class="lh35">
                            <b class="red">为了您的隐私，我们将会用不透明材料封装，快递单上统一标注为【玩具】,确保您的信息不会被他人知晓</b>
                        </p>
                    </div>
                    <!--gdes over-->
                </div>
                <!--datail over-->
                <detail-review :oneTalk="shopInfo.one_talk" :talk_num="shopInfo.talk_num" ></detail-review>
                
                <!--comment over-->
                <div id="recoment" class="des rel">
                    <div class="g_t over alR">
                        <div class="left fB">
                            <em class="red">3F</em> 相关推荐
                            <em class="gray pl10">RECOMMENT</em>
                        </div>
                    </div>
                    <div id="gbg" class="mt5">
                        <div class="vl over">
                            <div v-for="(tuijian,index) in product.slice(0,6)" :key="index">
                                <router-link :to="{path:'/detail', query:{id:tuijian.id}}" target="_blank" class="gba">
                                    <p class="gb_d">
                                        <img :src="tuijian.piclink" width="270" height="270" class="gb_m">
                                    </p>
                                    <div class="gb_p">
                                        <p>{{tuijian.title}}</p>
                                        <p class="gb_at">{{tuijian.ctitle}}<em class="gb_lu">|</em>同类推荐</p>
                                        <p>
                                            <b class="red"><em class="rmb">¥</em>{{tuijian.price}}</b>
                                        </p>
                                    </div>
                                </router-link>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <!--recoment over-->
                <div id="shouhou" class="des">
                    <div class="g_t fB">
                        <em class="red">4F</em>
                        优质服务
                        <em class="gray pl10">SERVICE</em>
                    </div>
                    <div class="pd20 ba_z yahei">
                        <table width="100%" border="0" class="lh35">
                            <tr>
                                <td width="50%">
                                    <a href="javascript:;" class="g_bza" rel="nofollow">
                                        <img src="https://s.cccgx.com/themes/v4/css/ft/gbz1.jpg" width="150" height="190" class="left mr10">
                                        <p>&nbsp;</p>
                                        <p>360度严密包装, 保密配送</p>
                                        <b class="f24 red">保密配送</b>
                                        <p>快递单无网站网址无商品名称</p>
                                    </a>
                                </td>
                                <td>
                                    <a href="javascript:;" class="g_bza" rel="nofollow">
                                        <img src="https://s.cccgx.com/themes/v4/css/ft/gbz2.jpg" width="150" height="190" class="left mr10">
                                        <p>&nbsp;</p>
                                        <p>正规品牌采购， 官方品牌授权</p>
                                        <b class="f24 red">正品保障</b>
                                        <p>上百国内国际知名品牌授权</p>
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <a href="javascript:;" class="g_bza" rel="nofollow">
                                        <img src="https://s.cccgx.com/themes/v4/css/ft/gbz3.jpg" width="150" height="190" class="left mr10">
                                        <p>&nbsp;</p>
                                        <p>全国上千城市</p>
                                        <b class="f24 red">免邮</b>
                                    </a>
                                </td>
                                <td>
                                    <a href="javascript:;" onclick="jieshou()" class="g_bza" rel="nofollow">
                                        <img src="https://s.cccgx.com/themes/v4/css/ft/gbz4.jpg" width="150" height="190" class="left mr10">
                                        <p>&nbsp;</p>
                                        <p>7*24小时客服在线服务</p>
                                        <b class="f24 red">优质客服</b>
                                    </a>
                                </td>
                            </tr>
                        </table>
                        <p>&nbsp;</p>
                        <p class="bline"></p>
                        <div class="pd20">
                            <p class="f18 c3"><b>夜樱情趣所售商品均保密配送</b></p>
                            <p>为了保障顾客的隐私利益，商品外包装不含任何敏感字样，快递单无网站网址无商品名称，快递单统一标注【玩具】字样，快递员及其他第三人均不会知晓产品。</p>
                            <p class="f18 c3"><b>全国上千城市免邮</b></p>
                            <p>全国上千城市免邮，偏远地区邮局可送达，如果您所在的城市是省会城市或者其它重要城市，1-2天 内即可送达（不可抗力情况除外），区县地区2-5天送达。</p>
                            <p class="f18 c3"><b>夜樱情趣所售商品均为原装正品</b></p>
                            <p>夜樱情趣所有出售的商品均来源于知名品牌公司，为各品牌授权的正规渠道正品，完善的供应链，正规的采购渠道，入仓全检保障，所有产品均通过国家相关质量认证。</p>
                            <p class="f18 c3"><b>质量问题满足退换货条件可退换</b></p>
                            <p>商品质量问题可提供退换货服务（需满足退换货标准）,若需要退换，请提前联系售后客服处理（配送包裹中含售后卡）。因情趣用品特殊性，安全套不退换，定制商品非质量问题不退换,使用后若出现损坏只提供维修服务,情趣内衣非破损问题不退换,功效类产品带塑封的一经拆封恕不提供退换货服务,给您带来不便请谅解。</p>
                            <p class="f18 c3"><b>360°购物保障，放心购买，安心使用</b></p>
                            <p>夜樱情趣打造完美服务，精选正规商品，确保每一位用户都买得安心，用得放心，如果您对夜樱情趣服务方面有任何疑问，我们竭诚为您服务！</p>
                        </div>
                    </div>
                </div>
            <!--shouhou over-->
            </div>
            <!--right over-->
            <div class="g_l right">
                <p class="glh3"><em class="f f16">&#xe633;</em> <b>相关分类</b></p>
                <div class="glb glbr" style="overflow:hidden;">
                    <div v-for="(cate,index) in soncate" :key="index">
                        <router-link :to="{path:'/shop/shopsearch', query:{cate_id:cate.id}}" target="_blank">
                            <div class="gr_tg" style="float:left;">{{cate.title}}</div>
                        </router-link>
                    </div>
                </div>
                <p class="glh3"><em class="f f16">&#xe636;</em> <b>看了又看</b></p>
                <div class="glb">
                    <div v-for="(see,index) in product.slice(0,6)" :key="index">
                        <router-link :to="{path:'/detail', query:{id:see.id}}" target="_blank" class="rx_a">
                            <img :src="see.piclink" width="160" height="160">
                            <p>{{see.title}}</p>
                            <p class="gb_at">{{see.ctitle}}<em class="gb_lu">|</em>同类推荐</p>
                            <p><b class="red"><em class="rmb">¥</em>{{see.price}}</b></p>
                        </router-link>
                    </div>
                </div>
                <!-- <p class="glh3"><em class="f f16">&#xe63b;</em> <b>在线客服</b></p>
                <div class="glb lh30">
                    <div onclick="jieshou()" title="点击咨询在线客服" class="rel hand">
                        <table width="160" height="140" border="0" class="alR kftab">
                            <tr>
                                <td width="44"><img src="https://s.cccgx.com/themes/v4/css/ft/zkf.gif" width="14" height="20"></td>
                                <td width="60"><img src="https://s.cccgx.com//themes/v4/css/ft/zkf.gif" width="14" height="20"></td>
                                <td><img src="https://s.cccgx.com/themes/v4/css/ft/zkf.gif" width="14" height="20"></td>
                            </tr>
                            <tr>
                                <td><img src="https://s.cccgx.com/themes/v4/css/ft/zkf.gif" width="14" height="20"></td>
                                <td><img src="https://s.cccgx.com/themes/v4/css/ft/zkf.gif" width="14" height="20"></td>
                                <td><img src="https://s.cccgx.com/themes/v4/css/ft/zkf.gif" width="14" height="20"></td>
                            </tr>
                        </table>
                        <img src="https://s.cccgx.com/themes/v4/css/ft/glkf.png" width="160" height="140">
                    </div>
                </div> -->
            <!--oneover-->
            </div>
            <!--right over-->
            <div class="clear"></div>
        </div>
        <!--content over-->
    </div>
</template>

<script>
import DetailReview from './detail_review.vue'
import {
  mapGetters,
  mapState
} from "vuex";
import CryptoJS from "crypto-js";

export default {
    components: {
        'detail-review' : DetailReview
    },
    filters: {//限制文本显示字数,超出部分用...代替
        ellipsis (value) {
        if (!value) return ''
        if (value.length > 10) {
            return value.slice(0,10) + '...'//0:下标,从第一个字开始显示,50:显示字数,多余用...代替
        }
            return value
        }
    },
    data(){
        return{
            active:"",
            activeFlase:"",
            shopInfo: {
                img_json: [],
                one_talk: {},
                recommend: [],
                hot: [],
                group: {
                    data: []
                }
            },
            number: 1,
            product:[],
            soncate:[],
            group: {},
            group_types: "",
            group_id: "",
            groupShow: false,
            picture:{},
            index:0,
            show:false,
            cart:{},
            proArr:[],
            cardList: [],
            first_pic:{},
            sku_iden:"",
            all_price:"",
            ptitle:"",
            pdesc:"",
            arr1:[],
            avatar: "",
            list:"",
            addOrder:{},
            title:"",
            ptitle:"",
            pskui:"",
            pskuId:"",
            addOrderInfo:{},
            pId:"",
            acart:"",
            parentList: [],
            skuTitle: [],
            shopItem: { piclink: "", iden: "" },
            showBtn: true,
            skuItemImg: "",
            value: 1,
            showList: [],
            checkSkuTitle: "",
            // 设置变量判断是否与所点击的一致
            ll:1
        }
    },
    
    computed: {
        ...mapState({
            car_num: state => state.car_num,
            user: state => state.user,
        }),
        price () {
            //5:71@1:3@35:28@23:25
            var skuList = this.shopInfo.sku_json;
            var iden = this.parentList.join('@')
            var rating = this.user.rating;
            var price = this.shopInfo.price;
            for (var i in skuList) {
                if (skuList[i].iden == iden) {
                if (typeof skuList[i].rating_json == 'object' && (skuList[i].rating_json.length == 0 || JSON.stringify(skuList[i].rating_json == '{}'))) {
                    price = skuList[i].price;
                }
                if (typeof skuList[i].rating_json == 'object') {
                    for (var j in skuList[i].rating_json) {
                    if (skuList[i].rating_json[j].id == rating) {
                        if (skuList[i].rating_json[j].price > 0) {
                        price = skuList[i].rating_json[j].price;
                        } else {
                        price = skuList[i].price;
                        }

                        break;
                    }
                    }
                }
                }
            }

            if (this.shopInfo.types == 4 && !this.group_types) {
                //拼团 且不为单人团
                price = this.shopInfo.group_discount * price / 10;
            }
            if (this.shopInfo.types == 19) {
                price = this.shopInfo.group_buy.price;
            }
            return price
        }
    },
    created(){

        /*页面挂载获取保存的localStorage值，渲染到页面上*/
        if(window.localStorage.getItem("user")){
            this.name = JSON.parse(window.localStorage.getItem("user")).username
            this.getShopDetails(this.$route.query.id);
            this.getProduct(this.$route.query.id);
            this.getSonAllCate(this.$route.query.id);
            this.getGroupUser(this.$route.query.id);
            this.addToCart();
            this.imgError();
            this.cartList();
        }
    },
    mounted(){
		if (JSON.stringify(this.shopInfo != "{}")) {
            var arr = this.shopInfo.attr;
            for (var i in arr) {
                if (arr[i].info.length > 0) {
                    this.parentList[i] = arr[i].info[0].parent_id + ":" + arr[i].info[0].sku_id;
                    this.skuTitle[i] = arr[i].title + ":" + arr[i].info[0].sku_title;
                    this.shopItem.piclink = arr[i].info[0].piclink || this.shopInfo.piclink;
                } else {
                    this.parentList[i] = "";
                    this.skuTitle[i] = "";
                }
            }
            this.$nextTick(() => {
                this.checkSkuTitle = this.skuTitle.join(" ");
                this.parentList.splice();
                try {
                    this.getCardLineNu(this.skuTitle);
                } catch (error) {
                // eslint-disable-next-line no-console

                }
                this.shopItem.piclink = this.shopInfo.piclink;
            });
            
        }
        
	},
    methods:{
        //点击详情四大概况
        on(){
            this.ll = 1;
        },
        on1(){
            this.ll = 2;
        },
        on2(){
            this.ll = 3;
        },
        on3(){
            this.ll = 4;
        },
        handleChange(value) {
        },
        getGroupUser (id) {
            this.$api.getShop.getGroupUser({id}).then(res => {
                if (res.code == 200) {
                    var arr = this.$fnc.oneArrTwoArr(res.result.group.data, 2);
                    res.result.group.data1 = arr;
                    this.group = res.result.group;
                }
            });
        },
        //获取数据
        getShopDetails(id) {
            var that = this;
            var params = {};
            params.id = id || "";
            that.$api.getShop.getShopDetails(params).then(res => {
                if (res.code == 200) {
                    if (res.result.types == 4) {
                        that.getGroupUser(res.result.id);
                    }
                    if (res.result.group == undefined) {
                        res.result.group = {
                            data: []
                        };
                    }
                    this.shopInfo = res.result;
                    console.log(this.shopInfo)
                    this.first_pic = res.result.piclink;
                    let jsonObj = JSON.parse(res.result.pro_params);
                    let arr1 = [];
                    jsonObj.forEach((item,index)=>{
                        this.arr1.push(item);
                    })
                    //价格区间
                    if (res.result.sku_id != 0) {
                        this.shopInfo.max_price = this.shopInfo.price;
                        this.shopInfo.min_price = this.shopInfo.price;
                        res.result.sku_json.forEach(sku => {
                            if (Number(sku.price) > Number(this.shopInfo.max_price)) {
                                this.shopInfo.max_price = sku.price;
                            }
                            if (Number(sku.price) < Number(this.shopInfo.min_price)) {
                                this.shopInfo.min_price = sku.price;
                            }
                        });
                    }
                    
                }
            });
        },
        //推荐和看了又看
        getProduct(id){
            var that = this;
            var params = {};
            params.id = id || "";
            that.$api.getShop.getProduct(params).then(res => {
                if (res.code == 200) {
                    this.product = [];
                    var arr = res.result.pro;
                    arr.forEach(item => {
                        this.product.push(item);
                    });
                }
            });
        },
        //获取指定父类所有子分类
        getSonAllCate(id){
            var that = this;
            var params = {};
            params.id = id || "";
            that.$api.getShop.getSonAllCate(params).then(res => {
                if (res.code == 200) {
                    this.soncate = [];
                    var arr = res.result.soncate;
                    arr.forEach(item => {
                        this.soncate.push(item);
                    });
                }
            });
        },
        //跳转
        catesearch(title,index){
            if(index == 0){
                this.$router.push(`/woman/`);
            }else if(index == 1){
                this.$router.push(`/man/`);
            }else if(index == 2){
                this.$router.push(`/biyuntao/`);
            }else if(index == 3){
                this.$router.push(`/zhuxing/`);
            }else if(index == 4){
                this.$router.push(`/lingleiwanju/`);
            }else if(index == 5){
                this.$router.push(`/tehui/`);
            }
        },
        //移出移入
        mouseover($event,index){
            $event.currentTarget.className="pl_m pl_on";
            if(this.picture == ""){
                this.picture = this.shopInfo.img_json[0];
            }else{
                this.picture = this.shopInfo.img_json[index];
            }
        },
        mouseout($event){
            $event.currentTarget.className="pl_m";
        },
        //默认第一张
        imgError() {
            // this.picture = this.shopInfo.img_json[0];
            var that = this;
            var params = {};
            params.id = this.$route.query.id || "";
            that.$api.getShop.getShopDetails(params).then(res => {
                if (res.code == 200) {
                    if (res.result.types == 4) {
                        that.getGroupUser(res.result.id);
                    }
                    if (res.result.group == undefined) {
                        res.result.group = {
                            data: []
                        };
                    }
                    this.shopInfo = res.result;
                    this.picture = res.result.piclink;
                }
            });
        },
        //选择不同套餐，改变价格值
        //选择不同套餐，改变价格值
        get_price () {
            if (this.shopItem.price) {
                return this.$fnc.toFixedZ(
                this.shopItem.price * this.shopInfo.discount_rob * 0.1,
                2
                );
            } else {
                return this.shopInfo.activity.limited_price;
            }
        },
        getCardLineNu (skuTitle) {
            var card = this.cardList;
            var cards = card.cardlist;
            var sid = this.$route.query.id || 0;
            if (
                card.cardID != sid &&
                cards[sid + "cardItem"] == undefined &&
                cards[sid + "cardItem"][0] == undefined &&
                cards[sid + "cardItem"][0].data.length == 0
            ) {
                return;
            } else {
                var str = skuTitle.join(" ").trim();
                var arr = cards[sid + "cardItem"][0].data;
                for (var i in arr) {
                if (arr[i].sku_cn.trim() == str) {
                    this.number = arr[i].number;
                    this.checkSkuTitle = str;
                    break;
                } else {
                    this.checkSkuTitle = str;
                    this.number = 1;
                }
                }
            }
        },
        showGg (sku, index, skuParent) {
            var l = 0,
                arr = [],
                a = [],
                that = this,
                skuList = [],
                str = "",
                skuIdList = [];

            if (
                that.parentList[index] &&
                that.parentList[index] == sku.parent_id + ":" + sku.sku_id
            ) {
                that.parentList[index] = "";
                that.skuTitle[index] = "";
                skuIdList[index] = "";
            } else {
                that.parentList[index] = sku.parent_id + ":" + sku.sku_id;
                that.skuTitle[index] = skuParent.title + ":" + sku.sku_title;
                skuIdList[index] = sku.sku_id;
            }
            that.parentList.splice();
            that.skuTitle.splice();
            try {
                this.getCardLineNu(that.skuTitle);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn("错误");
            }

            l = that.shopInfo.attr.length || 0;
            arr = that.parentList;
            a = arr.filter(item => {
                return item;
            });

            if (a.length == l) {
                skuList = that.shopInfo.sku_json;
                str = a.join("@");
                for (var i = 0; i <= skuList.length; i++) {
                    if (skuList[i] != undefined && str == skuList[i].iden) {
                        if (!skuList[i].piclink) {
                        this.skuItemImg = this.shopItem.piclink;
                        }
                        this.shopItem = skuList[i];
                        if (skuList[i].rating_json && skuList[i].rating_json.length > 0) {
                        for (var j in skuList[i].rating_json) {
                            if (
                            this.$store.state.user.rating ==
                            skuList[i].rating_json[j].id &&
                            skuList[i].rating_json[j].price > 0
                            ) {
                            this.shopItem.price = skuList[i].rating_json[j].price;
                            }
                        }
                        }
                        break;
                    }
                }
                // eslint-disable-next-line no-redeclare
                var a = [];
                var attr = this.shopInfo.attr;
                // eslint-disable-next-line no-redeclare
                for (var i in attr) {
                    if (attr[i].info) {
                        // eslint-disable-next-line no-redeclare
                        for (var j in attr[i].info) {
                        a.push(attr[i].info[j]);
                        }
                    }
                }
                var iden = [];

                if (this.shopItem.iden && this.shopItem.iden.indexOf("@") >= 0) {
                    iden = this.shopItem.iden.split("@");
                } else if (this.shopItem.iden) {
                    iden = this.shopItem.iden.split();
                }
                for (var k in a) {
                // eslint-disable-next-line no-redeclare
                for (var j in iden) {
                    if (a[k].parent_id + ":" + a[k].sku_id == iden[j] && a[k].piclink) {
                        this.skuItemImg = a[k].piclink;
                        break;
                    }
                }
                }
            } else {
                // var pic = this.shopItem.piclink
                this.showBtn = true;
                var img = sku.piclink;
                if (img) {
                    this.skuItemImg = img;
                }
            }
            if (this.skuItemImg) {
                this.$set(this.shopItem, "piclink", this.skuItemImg);
            } else {
                this.skuItemImg = "";
            }

            var eIndex = 0;
            for (var e in this.parentList) {
                if (this.parentList[e] == "") {
                    eIndex++;
                }
            }
            if (eIndex >= this.parentList.length) {
                this.skuItemImg = "";
                this.$set(this.shopItem, "piclink", this.shopInfo.piclink);
            }
            this.picture = this.skuItemImg;
            
        },
        taocan(item,idx){
            this.index=idx;
            this.shopInfo.price = this.shopInfo.sku_json[idx].price;
        },
        getCardNumber () {
            var cart_params = {};
            cart_params.uid = JSON.parse(window.localStorage.getItem("user")).id;
            this.$api.getShop.getCardNumber(cart_params).then(res => {
                if (res.code == 200) {
                    this.shopInfo.cart_number = res.result.number;
                    this.shopInfo.all_cart_number = res.result.all_product;
                }
            });
        },
        addToCart(){
            if(this.name != "" && this.name != undefined){
                //获取产品的全部信息
                var id = this.$route.query.id;
                var params = {};
                params.pid = id || "";
                //获取product_sku中iden的值
                this.$api.getShop.getIden(params).then(res => {
                    if (res.code == 200) {
                        res.result.forEach((item,i) => {
                            if(this.index == i){
                                this.sku_iden = item.iden;
                            }
                        });
                    }
                });
                var cart_id = this.$route.query.id;
                var cart_params = {};
                cart_params.pid = cart_id || "";
                cart_params.number = this.number;
                cart_params.sku_iden = this.sku_iden;
                cart_params.uid = JSON.parse(window.localStorage.getItem("user")).id;
                this.$api.getShop.addCart(cart_params).then(res=>{
                    if(res.code == 200){
                        this.active="display: block;";
                        this.getCardNumber();
                    }
                })
            }else{
                this.$alert('请先登录！再继续愉快的购物哦！', '提示', {
                    confirmButtonText: '确定',
                });
                this.$router.push('/login')
            }
        },
        buycar(){
			//指定跳转地址
			if(this.name != ""){
				//指定跳转地址
				this.$router.push('/car')
			}else{
                this.$alert('请先登录！再继续愉快的购物哦！', '提示', {
                    confirmButtonText: '确定',
                });
				this.$router.push('/login')
			}
		},
        closeT(){
            this.active="display: none;";
        },
        closeCT(){
            this.activeFlase="display: none;";
        },
        cartList(){
            var cart_params = {};
            cart_params.uid = JSON.parse(window.localStorage.getItem("user")).id;
            this.$api.getShop.getCartList(cart_params).then(res => {
                if (res.code == 200) {
                    this.all_price = res.result[0].all_price;
                }
            });
        },
        //获取地址列表
        getAddress(id){
            var params = {};
            params.id = id || "";
            this.$api.getUser.getAddress(params).then(res=>{
                this.list = [];
                var arr = res.result;
                if(arr != ""){
                    arr.forEach((item,index)=>{
                        this.list.push(item);
                        var address = JSON.stringify(this.list[0]);//将获取到的数据转换为json数据
                        window.localStorage.setItem('address', address);
                    })
                }else{
                    var address = JSON.stringify('暂无收货地址可使用');
                    window.localStorage.setItem('address', address);
                }
            })
        },
        lijiBuy(){       
            if(this.name != "" && this.name != undefined){
                //判断是否添加了套餐
                if(this.shopInfo.attr.length != 0){
                    if(this.shopItem.piclink != undefined){
                        const data = JSON.stringify(this.shopItem);
                        window.localStorage.setItem("productData",data);
                        //加密操作
                        const number = JSON.stringify(this.number);
                        const payPrice = JSON.stringify(this.price).replace("\"","").replace("\"","");
                        let Number = CryptoJS.AES.encrypt(number, "secretkey1").toString(); 
                        let PayPrice = CryptoJS.AES.encrypt(payPrice, "secretkey1").toString(); 
                        localStorage.setItem("number", Number);//本地存储
                        localStorage.setItem("payPrice", PayPrice);//本地存储
                        this.$router.push({path:'/buy_liji', query:{showVideo:1}})
                    }else{
                        this.$alert('请选择其中一种套餐', '提示', {
                            confirmButtonText: '确定',
                        });
                    }
                }else{
                    const data = JSON.stringify(this.shopInfo.sku_json[this.index]);
                    window.localStorage.setItem("productData",data);
                    //加密操作
                    const number = JSON.stringify(this.number);
                    const payPrice = JSON.stringify(this.price).replace("\"","").replace("\"","");
                    let Number = CryptoJS.AES.encrypt(number, "secretkey1").toString(); 
                    let PayPrice = CryptoJS.AES.encrypt(payPrice, "secretkey1").toString(); 
                    localStorage.setItem("number", Number);//本地存储
                    localStorage.setItem("payPrice", PayPrice);//本地存储
                    this.$router.push({path:'/buy_liji', query:{showVideo:1}})
                }
                
                
            }else{
                this.$alert('请先登录！再继续愉快的购物哦！', '提示', {
                    confirmButtonText: '确定',
                });
                this.$router.push('/login')
            }
        },
        coupon(){
            this.activeFlase="display: block;";
        },
        user_coupon_zjlq(item){
            item.money = Math.floor(parseFloat(item.money) * 100) / 100;
            if(item.pay_types == 1){
                this.$confirm(`是否消耗${item.jf_change}积分兑换${item.money}元优惠券`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$api.getShop.exchange_mark({ id: item.id,uid: JSON.parse(window.localStorage.getItem("user")).id}).then((res) => {
                        if (res.code == 200) {
                            this.$alert('兑换成功', '提示', {
                                confirmButtonText: '确定',
                            });
                            this.activeFlase="display: none;";
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });          
                });
            }else if(item.pay_types == 2){
                this.$confirm(`是否消耗￥${item.jf_change}兑换${item.money}元优惠券`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$api.getCoupon.coupon_packet_ye({ id: item.id,uid: JSON.parse(window.localStorage.getItem("user")).id }).then((res) => {
                        if (res.code == 200) {
                            this.$alert('兑换成功', '提示', {
                                confirmButtonText: '确定',
                            });
                            this.activeFlase="display: none;";
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });          
                });
            } else if (item.pay_types == 0) {
                this.$confirm(`是否领取优惠券`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$api.getShop.getLingquCoupon({ id: item.id,uid: JSON.parse(window.localStorage.getItem("user")).id }).then((res) => {
                        if (res.code == 200) {
                            this.$alert('领取成功', '提示', {
                                confirmButtonText: '确定',
                            });
                            this.activeFlase="display: none;";
                        }else{
                            this.$alert('已领取过了，请消费已有的优惠券再来领取！', '提示', {
                                confirmButtonText: '确定',
                            });
                            this.activeFlase="display: none;";
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });          
                });
            }
        },
        changesc () {
            if (this.shopInfo.collect == true) {
                this.shopInfo.collect = false;
            } else {
                this.shopInfo.collect = true;
            }
            var params = {};
            params.id = this.$route.query.id || '';
            params.uid = JSON.parse(window.localStorage.getItem("user")).id;
            this.$api.getShop.getGz(params).then(res => {
                if (res.code == 200) {
                    if(res.result == "收藏成功"){
                        this.$alert(`${res.result}`, '提示', {
                            confirmButtonText: '确定',
                        });
                    }else{
                        this.$alert(`${res.result}`, '提示', {
                            confirmButtonText: '确定',
                        });
                    }
                }
            })
        }
    }
};
</script>

<style scoped>
/* .active{display: none;} */
.coupon_tishi {
    width: 500px;
    /* height: 90px; */
    background-color: #dde4ea;
    border: 2px solid #f00180;
    -webkit-box-shadow: 1px 1px 3px #ccc;
    box-shadow: 1px 1px 3px #ccc;
    padding: 15px;
    position: absolute;
    /* bottom: 0px; */
    left: 10px;
    z-index: 2;
    display: none;
    color: #333;
    line-height: 25px;
    border-radius: 8px;
}
.shop_con {
    background: url(../../assets/image/coupon.png) no-repeat;
    width: 179px;
    height: 50px;
    background-size: 100% 100%;
    font-size: 16px;
    line-height: 50px;
    color: #fff;
    text-align: center;
    float: left;
    margin-right: 10px;
    margin-left:0px;
    cursor: pointer;
}

#jba{
    /* 粘性定位 */
    position: sticky;
    top: 0;
    z-index: 999;
} 

.ll{
    border-top: 2px solid #f00180;
    border-right: 1px solid #ddd;
    border-left: 1px solid #ddd;
    line-height: 42px;
}

.ll a{
    border: none;
    color: #f00180;
    font-weight: bold;
}

.ll:after{
    content: ' ';
    display: block;
    border-width: 5px;
    border-style: solid;
    border-color: #b00000 transparent transparent;
    width: 0;
    height: 0;
    font-family: arial;
    position: absolute;
    top: -1px;
    left: 50%;
    margin-left: -5px;
}
</style>



// WEBPACK FOOTER //
// src/components/detail/index.vue